import React, { useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faGift } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useAppNavigate } from '../../../../context/AppContext'
import PandaModal from '../../../../components/panda-modal/PandaModal'
import { IGeneralInfo } from '../../../../types/app'
import { getStorageKey } from '../../../../utils/appType'
import { confetti, haptic } from '../../../../utils/fx'

type Props = {
  isOpen: boolean
  setIsOpen?: (isOpen: boolean) => void
  generalInfo: IGeneralInfo
  orderPrice: number
}

const SuccessModal = (props: Props) => {
  const { t } = useTranslation()
  const navigate = useAppNavigate()

  const roulettePrize = localStorage.getItem(getStorageKey('roulettePrize'))

  useEffect(() => {
    if (props.isOpen) {
      haptic([20, 40, 20])
      confetti()
    }
  }, [props.isOpen])

  const close = () => {
    localStorage.removeItem(getStorageKey('pendingOrderSuccess'))
    sessionStorage.removeItem('orderCompleted')
    localStorage.removeItem(getStorageKey('rouletteWinningPrize'))
    localStorage.removeItem(getStorageKey('roulettePrize'))
    localStorage.removeItem(getStorageKey('successMessage'))
    props.setIsOpen?.(false)
    navigate('/')
  }

  return (
    <PandaModal
      isOpen={props.isOpen}
      onClose={close}
      actionLabel={t('CLOSE')}
      title={t('THANKS_FOR_ORDER')}
      badge={faCheck}
    >
      <p>{t('OPERATOR_CALL_SOON')}</p>
      {roulettePrize && (
        <div className='panda-modal__prize'>
          <FontAwesomeIcon icon={faGift} /> {t('YOU_WON')}: {roulettePrize}!
        </div>
      )}
    </PandaModal>
  )
}

export default SuccessModal
